import { wrappedWithSizes } from './withSizes'
import { isMobile, isTablet, isDesktop, calculateSpaceWithFactor } from './responsive'

const getBreakpoint = ({ isDesktop, isTablet, isMobile }) => {
  if (isDesktop) return 'desktop'
  if (isTablet) return 'tablet'
  return 'mobile'
}

export const withResponsive = WrappedComponent =>
  wrappedWithSizes(({ width }) => {
    const props = {
      isDesktop: isDesktop(width),
      isTablet: isTablet(width),
      isMobile: isMobile(width),
      isWeb: true
    }

    return {
      ...props,
      gutter: calculateSpaceWithFactor(props),
      breakpoint: getBreakpoint(props)
    }
  })(WrappedComponent)
